import * as React from 'react';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import Divider from '@mui/material/Divider';
import ListItemText from '@mui/material/ListItemText';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import Avatar from '@mui/material/Avatar';
import Typography from '@mui/material/Typography';

/* __next_internal_client_entry_do_not_use__ default auto */ import { createDemoClient } from '@mui/internal-core-docs/utils/createDemoClient';
const ClientProvider = createDemoClient(import.meta.url, { precompute: { externals: { react: React, "@mui/material/List": List, "@mui/material/ListItem": ListItem, "@mui/material/Divider": Divider, "@mui/material/ListItemText": ListItemText, "@mui/material/ListItemAvatar": ListItemAvatar, "@mui/material/Avatar": Avatar, "@mui/material/Typography": Typography } } });
export default ClientProvider;
